export default __webpack_public_path__ + "static/media/family.ee8257ad.svg";